export enum ActiveFilterEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
